module.exports = __webpack_public_path__ + "024f548738dd491f757a4287d9ec771a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/painted-nails-blue.png
// module id = 2404
// module chunks = 0